import { db, collection, addDoc, getDocs, query, orderBy, handleFirestoreError, OperationType } from '../src/firebase';
import * as XLSX from 'xlsx';

export interface UsageData {
  section: string;
  name?: string;
  schoolName?: string;
  udiseCode?: string;
  className?: string;
  panNumber?: string;
  pranNumber?: string;
  mobileNumber?: string;
  period?: string;
  amount?: string;
  timestamp?: string;
  id?: string;
}

export const saveUsageData = async (data: Omit<UsageData, 'timestamp' | 'id'>) => {
  try {
    const newItem = {
      ...data,
      timestamp: new Date().toISOString()
    };
    await addDoc(collection(db, 'usage'), newItem);
    return { success: true };
  } catch (error) {
    handleFirestoreError(error, OperationType.CREATE, 'usage');
    return { success: false };
  }
};

export const getUsageData = async (): Promise<UsageData[]> => {
  try {
    const q = query(collection(db, 'usage'), orderBy('timestamp', 'desc'));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({ ...doc.data(), id: doc.id })) as UsageData[];
  } catch (error) {
    handleFirestoreError(error, OperationType.LIST, 'usage');
    return [];
  }
};

export const downloadUsageExcel = async (section: string = 'all') => {
  const logs = await getUsageData();
  const filteredLogs = section === 'all' ? logs : logs.filter(log => log.section === section);
  
  const worksheet = XLSX.utils.json_to_sheet(filteredLogs);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Usage Logs");
  XLSX.writeFile(workbook, `Usage_Logs_${section}_${new Date().toISOString().split('T')[0]}.xlsx`);
};
